module.exports = __webpack_public_path__ + "img/mountain_xs.96bc1c82.png";